import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/navbar.css';
import logo from '../assets/gr/mdxpslogo.png';

const NavBar = ({ isAdminLoggedIn, onLoginClick, onLogoutClick }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLogoutClick = () => {
        onLogoutClick();
        navigate('/'); // Redirect to homepage after logout
    };

    return (
        <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
            <div className="navbar-logo">
                <Link to="/">
                    <img
                        src={logo}
                        alt="MD Express Fundraising Logo"
                        className="navbar-logo-img"
                    />
                </Link>
                <span className="navbar-title">MD Express Fundraising</span>
            </div>
            <ul className="navbar-links">
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/about">About</Link>
                </li>
                <li>
                    <Link to="/faq">FAQ</Link>
                </li>
                {isAdminLoggedIn && (
                    <li>
                        <Link to="/admin" className="admin-link">
                            Admin
                        </Link>
                    </li>
                )}
                <li>
                    {isAdminLoggedIn ? (
                        <Link
                            className="admin-link logout-button"
                            onClick={handleLogoutClick}
                        >
                            Logout
                        </Link>
                    ) : (
                        <Link
                            className="login-button"
                            onClick={onLoginClick}
                        >
                            Login
                        </Link>
                    )}
                </li>
            </ul>
        </nav>
    );
};

export default NavBar;